import MediumsDao from "../infrastructure/dao/MediumsDao";
import { OfferCreatorFilterOptions } from "../view/page/offer-panel/offer-creator/common/Filters";
import OffersDao from "../infrastructure/dao/OffersDao";
import { NumberishId } from "../model/type";

export const getMediumFilterOptions = (dao: OffersDao): GetMediumFilterOptions => offerId => {
    return dao.getFilterOptions(offerId);
}
export default getMediumFilterOptions;

export type GetMediumFilterOptions = (offerId: NumberishId) => Promise<OfferCreatorFilterOptions>;